module.exports = __webpack_public_path__ + "static/img/histrocial-sign-novalloy.2b7b9e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/historical/histrocial-sign-novalloy.jpg
// module id = 1033
// module chunks = 0